import axios from 'axios'

export const FETCH_ALL_DEVICES_SUCCESS = 'FETCH_ALL_DEVICES_SUCCESS'

export function parseDevice (deviceData, rest) {
  return {
    id: deviceData._id,
    placeName: deviceData.place_name,
    deviceId: deviceData.device_id,
    serviceId: deviceData.service_id,
    status: deviceData.status,
    storeName: deviceData.store_name,
    type: deviceData.type,
    ...rest
  }
}

export const fetchAllDevices = () => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      axios.get('camera/list').then(response => {
        dispatch({
          type: FETCH_ALL_DEVICES_SUCCESS,
          payload: response.data.slice(0, 50) // slice(0, 50) should removed when release
            .map(item => ({
              id: item.device_id,
              name: item.place_name
            }))
        })
        resolve()
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/devices.js